import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import langEn from "./lang-en.json";
import langKo from "./lang-ko.json";

const resources = { en: langEn, ko: langKo };
// const resources = { en: langEn, ko: langEn };

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    whitelist: ["ko", "en"],
    fallbackLng: "en",
    debug: false,
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: { escapeValue: false },
    detection: {
      order: ["navigator", "path"],
    },
    react: { useSuspense: false },
  });

export default i18n;
